import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _maxBy from 'lodash/maxBy';
import { useStores } from '../recipes';
import { Driver, Task } from '@bringg/types';
import TasksStoreAdapter from 'bringg-web/stores/tasks/tasks-store-adapter';

const getDriverLastTask = (driver, tasksStore: TasksStoreAdapter) => {
	const tasks = tasksStore.getOpen().filter(task => task.user_id === driver.id);

	return _maxBy(tasks, (task: Task) => {
		const wayPointWithMaxETL = _maxBy(task.way_points, wayPoint => {
			if (wayPoint.etl) {
				return new Date(wayPoint.etl).getTime();
			} else {
				return Number.MIN_VALUE;
			}
		});
		if (!_isNil(wayPointWithMaxETL?.etl)) {
			return new Date(wayPointWithMaxETL.etl).getTime();
		}
		if (task.scheduled_at) {
			return new Date(task.scheduled_at).getTime();
		} else {
			return Number.MIN_VALUE;
		}
	});
};

const getTimeFromTask = task => {
	if (task.way_points[task.way_points?.length - 1]?.etl) {
		return new Date(task.way_points[task.way_points.length - 1].etl).getTime();
	}
	if (task.scheduled_at) {
		return new Date(task.scheduled_at).getTime();
	}

	return Number.MAX_VALUE;
};

const getAddressFromTask = (task: Task) => {
	return task.way_points?.[task.way_points?.length - 1].address;
};

const getVehicleTitleByType = (driver, vehiclesStore, vehicleTypesStore) => {
	const vehicles = driver.vehicles;
	if (_isEmpty(vehicles)) {
		return null;
	}
	const vehicleTypeId = vehiclesStore.get(vehicles[0].id)?.vehicle_type_id;
	return vehicleTypesStore.get(vehicleTypeId)?.title;
};

export const useAssignDriverSelectItem = (driver: Driver) => {
	const { tasksStore, vehiclesStore, vehicleTypesStore } = useStores();

	const lastTask = getDriverLastTask(driver, tasksStore);
	const driverFreeTime = lastTask ? getTimeFromTask(lastTask) : undefined;
	const driverLastAddress = lastTask ? getAddressFromTask(lastTask) : driver.estimated_last_address;
	const vehicleTitleByType = getVehicleTitleByType(driver, vehiclesStore, vehicleTypesStore);

	return { driverFreeTime, driverLastAddress, vehicleTitleByType };
};
